import { FETCH_CANCEL, FETCH_END, FETCH_ERROR, FETCH_START, FETCH_ON_UPLOAD_PROGRESS, FETCH_ON_UPLOAD_SUCCESS, } from '../actions/FetchActions';
import { deleteListItem } from '../helpers/common';
const initialState = {
    loadingApis: [],
    loadings: {},
};
/**
 * 引数からキーを作成
 * @param apiAction
 * @returns {string|*}
 */
const parseApiAction = (apiAction) => {
    const { meta, type: name } = apiAction;
    const { id, progress } = meta || {};
    const key = id ? `${name}_${id}` : name;
    return { id, key, progress };
};
// eslint-disable-next-line default-param-last
export default (state = initialState, action) => {
    const { apiAction, noLoading, type } = action;
    if (noLoading) {
        return state;
    }
    switch (type) {
        case FETCH_START: {
            const { loadingApis } = state;
            const { key } = parseApiAction(apiAction);
            return Object.assign(Object.assign({}, state), { loadingApis: [...loadingApis, apiAction], loadings: { [key]: true } });
        }
        case FETCH_END:
        case FETCH_ERROR:
        case FETCH_CANCEL: {
            const { loadingApis } = state;
            const { key } = parseApiAction(apiAction);
            return Object.assign(Object.assign({}, state), { loadingApis: deleteListItem(loadingApis, apiAction), loadings: { [key]: false } });
        }
        // アップロード進捗状況の更新
        case FETCH_ON_UPLOAD_PROGRESS: {
            const { loadingApis } = state;
            const { id, progress } = parseApiAction(apiAction);
            const index = loadingApis.findIndex((v) => v.type === FETCH_ON_UPLOAD_PROGRESS && v.meta.id === id);
            let list = loadingApis;
            if (index >= 0) {
                list[index] = Object.assign(Object.assign({}, list[index]), { meta: Object.assign(Object.assign({}, list[index].meta), { progress }) });
            }
            else {
                list = [...list, apiAction];
            }
            return Object.assign(Object.assign({}, state), { loadingApis: list });
        }
        // アップロード完了
        case FETCH_ON_UPLOAD_SUCCESS: {
            const { loadingApis } = state;
            const { id } = parseApiAction(apiAction);
            const index = loadingApis.findIndex((v) => v.type === FETCH_ON_UPLOAD_PROGRESS && v.meta.id === id);
            const list = loadingApis;
            if (index >= 0) {
                list.splice(index, 1);
            }
            return Object.assign(Object.assign({}, state), { loadingApis: list });
        }
        default: {
            return state;
        }
    }
};
